export default "__VITE_ASSET__Bpc4vw1V__"